import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/", { replace: true }); return; }
    (async () => {
      try {
        await exchangeGoogle(sessionId);
        const dest = (window.location.pathname && window.location.pathname !== "/dashboard") ? window.location.pathname : "/";
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 1800);
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="ely" style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div className="eyebrow">ELY WELLBEING</div>
        <h2 style={{ marginTop: ".4rem" }}>{error || "Signing you in…"}</h2>
      </div>
    </div>
  );
}
